import React from "react"
import styled from "styled-components"

import TitleHeader from "components/presenters/header/TitleHeader"

import PushConfigSetting from "components/modules/mypage/PushConfigSetting/PushConfigSetting"

export default function NotificationSettingLayout() {
  return (
    <NotificationSttingSection>
      <HeaderWrapper>
        <TitleHeader title={"알림설정"} />
      </HeaderWrapper>
      <BodyWrapper>
        <PushConfigSetting />
      </BodyWrapper>
    </NotificationSttingSection>
  )
}

const NotificationSttingSection = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`

const HeaderWrapper = styled.div`
  flex: 0 1 auto;
  height: calc(100vw * (51 / 375));
  max-height: calc(100vw * (51 / 375));
  min-height: calc(100vw * (51 / 375));
`

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  height: 100%;
  margin-bottom: calc(100vw * (72 / 375));
  overflow-y: scroll;
`
